/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as BadgeDefs from "./defs.defs.js";

const $nsid = "place.stream.badge.getValidBadges";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"streamer":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"did"}))});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"badges":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<BadgeDefs.BadgeView>((() => BadgeDefs.badgeView) as any), )});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get valid badges for the authenticated user, optionally in the context of a specific streamer's chat */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;
